<br>
<form [formGroup]="userPasswordForm" (ngSubmit)="onClickUserPasswordForm()">
  <div class="row c-row">
    <div class="col-sm-6">
      <mat-form-field>
        <input matInput placeholder="Current Password" type="password" formControlName="password" maxlength="10">
        <mat-error *ngIf="submittedUserPasswordForm && f3.password.errors?.required" class="invalid-feedback">
          Current Password is required
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row c-row">
    <div class="col-sm-6">
      <mat-form-field>
        <input matInput placeholder="New Password" type="password" formControlName="newPassword" maxlength="10">
        <mat-error *ngIf="submittedUserPasswordForm && f3.newPassword.errors?.required" class="invalid-feedback">
          New Password is required
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row c-row">
    <div class="col-sm-6">
      <mat-form-field>
        <input matInput placeholder="Re-type Password" type="password" formControlName="rePassword" maxlength="10">
        <mat-error *ngIf="submittedUserPasswordForm && f3.rePassword.errors?.required" class="invalid-feedback">
          Re-type Password is required
        </mat-error>
        <mat-error class="invalid-feedback"
          *ngIf="(f3.rePassword.errors?.mustMatch && (userPasswordForm.touched || userPasswordForm.dirty))">
          New Password and Re-type doesn't match.
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row c-row text-right">
    <div class="col-sm-6">
      <button mat-raised-button type="submit" color="primary">Change</button>
    </div>
  </div>
</form>